/* instanbul ignore next */
export const normalizeAccents = inputString => {
    if (!inputString) {
        return inputString;
    }

    return inputString.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
};
